import Plyr from 'plyr';
import controls from '../audiocontrols';
import Dropin from '../components/Dropin';
import tippy from 'tippy.js';
// Fix for ios range..
import RangeTouch from 'rangetouch';
import { scrollPageTo } from '../utils';

export default class AudioPlayer {
	constructor() {
		this.breakpoint = window.matchMedia('(max-width:767px)');
		this.element = document.querySelector('.c-audio-bar');
		this.isPlaying = false;
		this.isOpen = false;
		this.currentTrackId = null;

		// Playlist
		this.playListData = null;
		this.playListEl = this.element.querySelector('[data-audio-bar-tracks]');
		this.playListToggle = this.element.querySelector('[data-toggle-playlist]');
		this.playListOpen = false;

		document.addEventListener('bless', ({ detail }) => {
			this.container = detail.next.container;
			this.init();
		});

		document.addEventListener('click', e => {
			const button = e.target.closest('[data-play="audio"]');
			const playlistButton = e.target.closest('[data-playlist]');

			if (button) {
				if (!button.dataset.playlistid) {
					this.unloadPlaylist();
				}

				if (button.dataset.id == this.currentTrackId && this.isPlaying) {
					this.pause();
				} else {
					this.open(button.dataset);
				}
			}

			if (playlistButton) {
				const urlHash = playlistButton.getAttribute('data-playlist');
				window.location.hash = '#' + urlHash;
			}
		});

		window.addEventListener('hashchange', (e) => {
			if (window.location.hash) {
				this.activatePlaylist(window.location.hash);
			}
		})

		// Toggle playlist knop in de playlist
		this.playListEl.addEventListener('click', e => {
			const playlistButton = e.target.closest('[data-toggle-playlist]');

			if (playlistButton) {
				this.togglePlaylist();
			}
		});

		this.playListToggle.addEventListener('click', e => {
			this.togglePlaylist();
		});

		document.addEventListener('filmstart', e => {
			this.close();
		});

		document.addEventListener('inlineaudioplaying', e => {
			this.close();
		});
	}

	activatePlaylist(hash) {
		if (!hash) {
			return;
		}

		const id = hash.replace('#', '');
		const playlistButton = document.querySelector(`[data-playlist="${id}"]`);

		if (!playlistButton) {
			return;
		}

		// In de toekomst is via ajax ophalen waarschijnlijk beter
		const data = JSON.parse(playlistButton.querySelector('script').innerHTML);

		setTimeout(() => {
			this.loadPlaylist(data);
		}, 1000);
	}

	init() {
		if (this.dropin) {
			this.dropin.destroy();
		}
		if (!this.isPlaying) {
			this.dropin = new Dropin(this.element, this.container, this);
		}

		if (this.player) {
			this.checkForNarration();

			// Set classes on play button
			this.addElStatusClasses('is-active');
			this.addElStatusClasses('is-playing');

			// Hide on transition if not playing
			//(TODO, change this to a 'leave' event instead of being checked on bless?)
			if (!this.isPlaying) {
				this.hide();
			}
			return;
		}

		if (window.location.hash) {
			const playlistSection = document.querySelector('#playlists');
			if (playlistSection) {
				setTimeout(() => {
					scrollPageTo(playlistSection, 2000);
				}, 1000);
			}
			this.activatePlaylist(window.location.hash);
		}

		const elm = document.querySelector('.c-audio-player');

		if (!elm) {
			return;
		}

		this.player = new Plyr(elm, {
			controls,
			loadSprite: false,
			seekTime: 10,
			blankVideo: 'data:video/mp4;base64,AAAAHGZ0eXBpc29tAAACAGlzb21pc28ybXA0MQAAAAhmcmVlAAAC721kYXQhEAUgpBv/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3pwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcCEQBSCkG//AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADengAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcAAAAsJtb292AAAAbG12aGQAAAAAAAAAAAAAAAAAAAPoAAAALwABAAABAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAAAB7HRyYWsAAABcdGtoZAAAAAMAAAAAAAAAAAAAAAIAAAAAAAAALwAAAAAAAAAAAAAAAQEAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAACRlZHRzAAAAHGVsc3QAAAAAAAAAAQAAAC8AAAAAAAEAAAAAAWRtZGlhAAAAIG1kaGQAAAAAAAAAAAAAAAAAAKxEAAAIAFXEAAAAAAAtaGRscgAAAAAAAAAAc291bgAAAAAAAAAAAAAAAFNvdW5kSGFuZGxlcgAAAAEPbWluZgAAABBzbWhkAAAAAAAAAAAAAAAkZGluZgAAABxkcmVmAAAAAAAAAAEAAAAMdXJsIAAAAAEAAADTc3RibAAAAGdzdHNkAAAAAAAAAAEAAABXbXA0YQAAAAAAAAABAAAAAAAAAAAAAgAQAAAAAKxEAAAAAAAzZXNkcwAAAAADgICAIgACAASAgIAUQBUAAAAAAfQAAAHz+QWAgIACEhAGgICAAQIAAAAYc3R0cwAAAAAAAAABAAAAAgAABAAAAAAcc3RzYwAAAAAAAAABAAAAAQAAAAIAAAABAAAAHHN0c3oAAAAAAAAAAAAAAAIAAAFzAAABdAAAABRzdGNvAAAAAAAAAAEAAAAsAAAAYnVkdGEAAABabWV0YQAAAAAAAAAhaGRscgAAAAAAAAAAbWRpcmFwcGwAAAAAAAAAAAAAAAAtaWxzdAAAACWpdG9vAAAAHWRhdGEAAAABAAAAAExhdmY1Ni40MC4xMDE=',
			volume: 1
		});

		setTimeout(() => {
			this.checkForNarration();
		}, 0);

		this.element.addEventListener('click', e => {

			if (e.target.closest('.c-audio-bar__close')) {
				this.close();
			}

			if (e.target.closest('[data-play]')) {
				this.togglePlay();
			}

			if (e.target.closest('[data-rewind]')) {
				this.rewind();
			}

			if (e.target.closest('[data-forward]')) {
				this.fastForward();
			}

			if (e.target.closest('.c-audio-bar__meta')) {
				if (this.breakpoint.matches === true) {
					this.toggleUnfold();
				}
			}
		});

		this.player.on('play', () => {
			this.element.classList.add('is-playing');
			this.element.classList.add('has-played');
			this.isPlaying = true;
			this.addElStatusClasses('is-active');
			this.addElStatusClasses('is-playing');
			this.setPlaylistImage();

			document.dispatchEvent(new CustomEvent('audioplayerplaying'));
		});

		this.player.on('pause', () => {
			this.element.classList.remove('is-playing');
			this.isPlaying = false;
			this.removeElStatusClasses(['is-playing']);
		});

		this.player.on('ended', () => {
			this.element.classList.remove('is-playing');
			this.isPlaying = false;

			const nextPodcast = this.getNextPlaylistTrack();

			if (nextPodcast) {
				this.open(nextPodcast);
			}
		});

		this.player.on('ready', () => {
			// if (!this.player.source) {
			// 	return;
			// }

			if (this.volumeTippies) {
				this.volumeTippies.forEach(volumeTippy => volumeTippy.destroy());
			}

			this.volumeTippies = tippy(this.element.querySelectorAll('[data-plyr="mute"]'), {
				content: reference => {
					return reference.nextElementSibling;
				},
				allowHTML: true,
				interactive: true,
				placement: 'top',
				theme: 'volume-slider',

				arrow: false,
				zIndex: -1,
				offset: [0, -34],
			});

			const seekInput = this.element.querySelector('[data-plyr="seek"]');
			const seekRange = new RangeTouch(seekInput);

			const volumeInput = this.element.querySelector('[data-plyr="volume"]');
			const volumeRange = new RangeTouch(volumeInput);
		});

	}

	togglePlaylist() {
		this.playListOpen ? this.closePlaylist() : this.openPlaylist();
	}

	openPlaylist() {
		this.playListEl.classList.add('is-open');
		this.playListOpen = true;
		this.element.classList.add('has-playlist-open');
		this.element.classList.remove('is-open');
	}

	closePlaylist() {
		history.pushState(null, null, ' ');

		this.playListEl.classList.remove('is-open');
		this.element.classList.remove('has-playlist-open');
		this.playListOpen = false;


		this.playListEl.scrollTo(0, 0);
	}

	unloadPlaylist() {
		this.closePlaylist();
		this.playListEl.innerHTML = '';
		this.playListData = null;
		this.element.classList.remove('has-playlist');
		this.playListToggle.classList.remove('is-active');
	}

	loadPlaylist(data) {
		if (!data) {
			return;
		}

		this.playListData = data;
		this.playListEl.innerHTML = data.html;
		this.playListToggle.classList.add('is-active');
		this.element.classList.add('has-playlist');

		this.openPlaylist();
		if (!data.podcasts.length) {
			return;
		}
		this.open(data.podcasts[0]); // Play the first podcast from the playlist
	}

	getCurrentPlaylistTrack() {
		if (!this.currentTrackId || !this.playListData) {
			return null;
		}

		return this.playListData.podcasts.find(podcast => podcast.id == this.currentTrackId);
	}

	getNextPlaylistTrack() {
		if (!this.currentTrackId || !this.playListData) {
			return null;
		}

		const index = this.playListData.podcasts.findIndex(podcast => podcast.id == this.currentTrackId);

		if (index < this.playListData.podcasts.length) {
			return this.playListData.podcasts[index + 1];
		}

		return null;
	}

	prepareClassNames(classNames) {
		return Array.isArray(classNames) ? classNames : [classNames];
	}

	// Remove status classNames from all [data-audio-element]
	removeElStatusClasses(classNames) {
		classNames = this.prepareClassNames(classNames);
		document.querySelectorAll(`[data-audio-element].${classNames.join('.')}`).forEach(el => el.classList.remove(...classNames));
	}

	// Set status classNames on [data-audio-element] (is-playing, is-active, etc.)
	addElStatusClasses(className) {
		this.removeElStatusClasses(className);

		if (!this.currentTrackId) {
			return;
		}

		// Fix for when source is already set in the case of a narration
		if (className == 'is-playing' && !this.isPlaying) {
			return;
		}

		const el = document.querySelector(`[data-id="${this.currentTrackId}"]`);

		if (!el) {
			return;
		}

		el.closest('[data-audio-element]')?.classList.add(className);
	}

	setPlaylistImage() {
		if (!this.playListData) {
			return;
		}

		const currentTrack = this.getCurrentPlaylistTrack();
		const container = this.playListEl.querySelector('[data-image-container]');

		if (currentTrack.image) {
			container.classList.add('has-image');
			container.innerHTML = currentTrack.image;
		} else {
			container.classList.remove('has-image');
			container.innerHTML = '';
		}
	}

	checkForNarration() {
		this.data = JSON.parse(this.container.querySelector('#container-data').innerHTML);
		this.narration = this.data['story-narration'];

		if (!this.narration || this.isPlaying) {
			return;
		}
		const data = {
			src: this.narration.audio,
			title: this.narration.title,
			author: this.narration.narrated_by,
			type: 'audio/mp3',
			play: 'audio',
			id: this.narration.id,
		};
		this.setSource(data);
	}

	togglePlay() {
		this.player.togglePlay();
	}

	fastForward() {
		this.player.forward();
	}

	rewind() {
		this.player.rewind();
	}

	show() {
		document.body.classList.add('body--audio-bar-dropin');
		this.isOpen = true;
	}

	hide() {
		if (!this.isPlaying) {
			document.body.classList.remove('body--audio-bar-dropin');
		}

		this.isOpen = false;

		this.removeElStatusClasses(['is-active']);
	}

	setAndShow(data) {
		this.show();

		if (this.player.source !== data.src) {
			this.setSource(data);
		}
	}

	open(data) {
		this.show();

		if (this.player.source !== data.src) {
			this.setSource(data);
		}

		this.play();
	}

	play() {
		this.player.play();
	}

	pause() {
		this.player.pause();
	}

	close() {
		this.pause();

		this.closePlaylist();

		setTimeout(() => {
			this.hide();
		}, 0);

		if (this.dropin) {
			this.dropin.destroy();
		}
	}

	setSource({ src, title, type, author, id }) {
		this.player.source = {
			type: 'audio',
			title,
			sources: [
				{
					src,
					type,
				},
			],
		};

		this.setTitle(title, author);
		this.track(title);
		this.currentTrackId = id;
	}

	setTitle(title, author) {
		const meta = this.element.querySelector('.c-audio-bar__meta');

		const html = `
			<div class="c-audio-bar__title">${title}</div>
			<div class="c-audio-bar__author">${author}</div>
		`;

		meta.innerHTML = html;
	}

	toggleUnfold() {
		const classList = this.element.classList;

		if (classList.contains('is-open')) {
			classList.remove('is-open');
		} else {
			classList.add('is-open');
			this.closePlaylist();
		}
	}

	track(title) {
		if (window.plausible) {
			plausible('Audio play', {
				props: {
					'Name': title,
				}
			});
		}
	}
}
